import React from "react";
import {Button, Checkbox, Col, Dropdown, Menu, Row, Spin} from "antd";
import {ChevronRightIcon, DiamondIcon, FlameIcon, KeyIcon, StorageBoxOutlineIcon} from "@components/icons/Icons";
import {EllipsisOutlined, SyncOutlined} from "@ant-design/icons";
import {formatDateTiny, formatNumber} from "@lib/format";
import {FmvPrice} from "@components/fmv-price";

const MyCollectionBoxListItemDesktop = ({
    box,
    showEditMultiple,
    isSelected,
    toggleSelected,
    navigate,
    showTotalFmv,
    postRefreshFmv,
    refreshFmvResponse,
    fmvUpdated,
    setEditBox,
    setShowRemoveBox,
    windowDimensions,
 }) => {

    return (
        <Row className="grid-list-item">
            {showEditMultiple && (
                <Col span={1} className="col-cbx">
                    <Checkbox checked={isSelected} onChange={() => toggleSelected(box.id)}/>
                </Col>
            )}

            <Col className="col-box-image">
                <div
                    className="box-image"
                    style={{background: `url(${box && box.image_url}) 0 45% no-repeat`, backgroundSize: "cover"}}
                    onClick={() => { navigate('box-issues?view='+box.id); }}
                >
                    <StorageBoxOutlineIcon className=" whiteCircleIconTiny" />
                </div>
            </Col>

            <Col className="col-desc flex-grow-1">
                <div className="text-title cursor-pointer titleLink" onClick={() => { navigate('box-issues?view='+box.id); }}>{box.name}</div>
                <div className="valueBadges mar-top-10 mar-bot-10" >
                    {box.overview.items_key > 0 && (<span className="pad-right-20"><div className="valueBadge keyIssue isActive"><KeyIcon /></div> ({box.overview.items_key})</span>)}
                    {box.overview.items_hot > 0 && (<span className="pad-right-20"><div className="valueBadge hotIssue isActive"><FlameIcon /></div> ({box.overview.items_hot})</span>)}
                    {box.overview.items_rare > 0 && (<span className="pad-right-20"><div className="valueBadge rareIssue isActive"><DiamondIcon /></div> ({box.overview.items_rare})</span>)}
                </div>
                <div className="ellipsis">
                    <div>
                        <p>{box.description}</p>
                    </div>
                </div>
            </Col>
            <Col span={4} className="flex-col">
                <div className="col-center">
                    {formatNumber(box.overview.items)}
                </div>
            </Col>
            <Col
                span={4}
                className={"flex-col " + (box.fmv_can_update ? 'cursor-pointer' : '')}
                onClick={(showTotalFmv && box.fmv_can_update) ? async () => {
                     await postRefreshFmv({box_id: box.id})
                } : undefined }
            >
                <div className="col-center">
                    {showTotalFmv ? (
                        <Spin spinning={refreshFmvResponse.isLoading}>
                            <Row className="flex-align-center">
                                <FmvPrice
                                    value={box.fmv}
                                    stale={box.fmv_is_stale}
                                    staleInfo="FMV data is stale, please update."
                                />
                                {box.fmv_can_update && (<SyncOutlined className={'fmv-update can-update'} />)}
                            </Row>
                            {(box.fmv_can_update && fmvUpdated) && (
                                <Row className="flex-align-center">
                                    <span className='font-10 text-grey'>Updated: {formatDateTiny(fmvUpdated)}</span>
                                </Row>
                            )}
                        </Spin>
                    ) : (
                        <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                    )}
                </div>
            </Col>
            <Col span={4} className="flex-col">
                <div className="flex-align-center flex-vertical-center height-100" >
                    <Dropdown className="greyButton selectButton" trigger={["click"]} overlay={(
                        <Menu >
                            <Menu.Item key={0} onClick={() => { if(setEditBox){ setEditBox(box) } }}>Edit Box Info</Menu.Item>
                            <Menu.Item key={1} onClick={() => setShowRemoveBox(true)}>Delete Box</Menu.Item>
                            {/*<Menu.Item key={2} disabled >Mark All As Sold</Menu.Item>*/}
                            {/*<Menu.Item key={3} disabled>Assign Location For All</Menu.Item>*/}
                        </Menu>
                    )}>
                        <Button size={"large"} className="mar-left-5">
                            <EllipsisOutlined className="font-12" />
                        </Button>
                    </Dropdown>

                    <Button
                        type="text"
                        size={"large"}
                        className="pad-0-10"
                        href={'/box-issues?view='+box.id}
                    >
                        <ChevronRightIcon className="icon30 iconGrey"/>
                    </Button>

                </div>
            </Col>
        </Row>
    );

};

export default MyCollectionBoxListItemDesktop;